import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateBuildingCommand,
  GetAllBuildingsCommand,
  GetBuildingByIdCommand,
  GetBuildingsByQueryCommand,
  UpdateBuildingCommand,
  UpdateStatusBuildingCommand,
} from './building.commands';
import {
  CreatedBuildingEvent,
  GotAllBuildingsEvent,
  GotBuildingByIdEvent,
  GotBuildingsByQueryEvent,
  UpdatedBuildingEvent,
  UpdatedStatusBuildingEvent,
} from './building.events';
import { BuildingEntity } from '@resident-select/domain/building';

@Injectable()
export class BuildingEffects {
  prefix = 'building';
  createBuildingCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllBuildingsCommand: Observable<Action<string>> & CreateEffectMetadata;
  getBuildingByIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  getBuildingsByQueryCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateBuildingCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateStatusBuildingCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createBuildingCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateBuildingCommand,
      CreatedBuildingEvent,
      this.prefix,
    );
    this.getAllBuildingsCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllBuildingsCommand,
      GotAllBuildingsEvent,
      this.prefix,
    );
    this.getBuildingByIdCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetBuildingByIdCommand,
      GotBuildingByIdEvent,
      this.prefix,
    );
    this.getBuildingsByQueryCommand = sciGuaduaHttpRequestHandler.handleEvent<{
      query: string;
    }>({
      command: GetBuildingsByQueryCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const data = httpResponse.data;
        const entities: BuildingEntity[] = Array.isArray(data) ? data : data ? [data] : [];

        return [GotBuildingsByQueryEvent({ entities, query: commandData.query })];
      },
    });
    this.updateBuildingCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateBuildingCommand,
      UpdatedBuildingEvent,
      this.prefix,
    );
    this.updateStatusBuildingCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateStatusBuildingCommand,
      UpdatedStatusBuildingEvent,
      this.prefix,
    );
  }
}
